import Base from "../base";


export default class ComentariosPreguntasService extends Base {
  static endpointUrl = "encuestas/comentarios_preguntas/";
}